import styled from 'styled-components';

import { IconChevronLeftCircle, IconChevronRightCircle, spaceMixin, token } from '@zillow/constellation';

export const StyledBackgroundImage = styled.div<{ urlSrc: string }>`
  align-items: center;
  background-image: url(${(props) => props.urlSrc});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: ${token('colors.backgroundDark')};
  border-radius: ${spaceMixin(0.5)};
  display: flex;
  height: 362px;
  justify-content: space-between;
  padding: ${spaceMixin('xs')};
  width: 100%;
`;

export const StyledLeftIcon = styled(IconChevronLeftCircle)`
  cursor: pointer;
  opacity: 85%;

  &:hover {
    opacity: 100%;
  }
`;

export const StyledRightIcon = styled(IconChevronRightCircle)`
  cursor: pointer;
  opacity: 85%;

  &:hover {
    opacity: 100%;
  }
`;

export const StyledCarouselContainer = styled.div`
  width: 100%;
  overflow: hidden;
  user-select: none;
`;

export const StyledCarouselSlot = styled.div`
  flex: 1 0 100%;
`;
